module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-login-main"
  }, [_c('div', {
    staticClass: "page-bg",
    attrs: {
      "id": "particles_bg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "login-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-fill-wrap"
  }, [_c('div', {
    staticClass: "form-item hf"
  }, [_c('div', {
    staticClass: "ipt-wrap ftp"
  }, [_c('i', {
    staticClass: "icon-label fa fa-user ftp"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "ipt",
    attrs: {
      "type": "text",
      "placeholder": "Please enter user name"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-item hf"
  }, [_c('div', {
    staticClass: "ipt-wrap ftp"
  }, [_c('i', {
    staticClass: "icon-label fa fa-lock ftp"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "ipt",
    attrs: {
      "type": "password",
      "placeholder": "Please enter your password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "login-btn",
    on: {
      "click": _vm.doLogin
    }
  }, [_vm._v("Login")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-title-wrap"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Welcome to log in")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-4d24c367","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/page/common/Login.vue
// module id = 763
// module chunks = 1